import React, { useEffect, useState } from "react";
import { FaPiggyBank } from "react-icons/fa";

import Popup from '../../../../../components/Popup';
import Input from '../../../../../components/Input'
import companyServices from "../../../../../services/admFin/companyServices";


export default function BankAccountPopUp(props) {
    const [banco, setBanco] = useState("");
    const [agencia, setAgencia] = useState("");
    const [numero, setNumero] = useState("");
    const [tipo, setTipo] = useState("");
    const [moeda, setMoeda] = useState("");
    const [saldo, setSaldo] = useState("");

    useEffect(() => {
        if (props.bankAccount && Object.keys(props.bankAccount).length > 0) {
            setBanco(props.bankAccount.banco);
            setAgencia(props.bankAccount.agencia);
            setNumero(props.bankAccount.numero);
            setTipo(props.bankAccount.tipo);
            setSaldo(props.bankAccount.saldo);
            setMoeda(props.bankAccount.moeda)
        }
    }, [props.bankAccount]);

    return (
        <Popup
            icon={<FaPiggyBank />}
            tittle={props.tittle}
            visibility={props.visibility}
            setVisibility={props.setVisibility}
        >
            <Input
                label="Banco*"
                placeholder="Digite o nome do banco"
                id="new-bank-account-popup-bank"
                onChange={(e) => setBanco(e.target.value)}
                value={banco}
            />
            
            <Input
                label="Agencia*"
                placeholder="Digite o número da agência"
                id="new-bank-account-popup-agency"
                onChange={(e) => setAgencia(String(e.target.value).replace(/\D/g, ''))}
                value={agencia}
            />

            <Input
                label="Número da Conta*"
                placeholder="Digite o número da conta"
                id="new-bank-account-popup-number"
                onChange={(e) => setNumero(String(e.target.value).replace(/\D/g, ''))}
                value={numero}
            />

            <Input
                label="Tipo da Conta*"
                placeholder="Digite o tipo da conta"
                id="new-bank-account-popup-type"
                onChange={(e) => setTipo(e.target.value)}
                value={tipo}
            />

            <Input
                label="Moeda*"
                type="select"
                noFilterOptions
                options={companyServices.moedaTypes.map(obj => obj[1])}
                placeholder="Digite a moeda que a empresa trabalha"
                id="new-company-popup-currency"
                onChange={(e) => setMoeda(e.target.value)}
                value={moeda}
            />

            <Input
                label={props.bankAccount ? "Saldo*" : "Saldo Inicial*"}
                type="currency"
                currency={moeda}
                placeholder="Digite o saldo inicial da conta com ponto para parte decimal"
                id="new-bank-account-popup-balance"
                onChange={(e) => setSaldo(String(e.target.value).replace(/,/g, '.'))}
                value={saldo}
            />

            <button onClick={() =>{
                const moedaId =  moeda === "" ? moeda : companyServices.moedaTypes.find(obj => obj[1] === moeda)[0];
                console.log(moedaId);
                props.onClick({ banco, agencia, numero, tipo, moeda: moedaId,saldo })
            }}>{props.buttonTittle}</button>
        </Popup>
    )
}